import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from './firebase';

const ImpersonationContext = createContext();

export function useImpersonation() {
  return useContext(ImpersonationContext);
}

export function ImpersonationProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [impersonatedUserId, setImpersonatedUserId] = useState(null);
  const [impersonatedEmail, setImpersonatedEmail] = useState(null);
  const [loading, setLoading] = useState(true);

  // The effective user ID - either impersonated or actual
  const effectiveUserId = impersonatedUserId || currentUser?.uid;

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      setCurrentUser(user);
      
      if (user) {
        // Check for superAdmin claim in ID token
        const tokenResult = await user.getIdTokenResult();
        setIsSuperAdmin(tokenResult.claims.superAdmin === true);
      } else {
        setIsSuperAdmin(false);
        setImpersonatedUserId(null);
        setImpersonatedEmail(null);
      }
      
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const startImpersonation = (userId, email) => {
    if (!isSuperAdmin) {
      console.error('Only superAdmin can impersonate');
      return;
    }
    console.log(`🎭 Starting impersonation of ${email} (${userId})`);
    setImpersonatedUserId(userId);
    setImpersonatedEmail(email);
  };

  const stopImpersonation = () => {
    console.log('🎭 Stopping impersonation');
    setImpersonatedUserId(null);
    setImpersonatedEmail(null);
  };

  const value = {
    currentUser,
    effectiveUserId,
    isSuperAdmin,
    isImpersonating: !!impersonatedUserId,
    impersonatedEmail,
    actualUserId: currentUser?.uid,
    startImpersonation,
    stopImpersonation,
    loading,
  };

  return (
    <ImpersonationContext.Provider value={value}>
      {children}
    </ImpersonationContext.Provider>
  );
}

export default ImpersonationContext;
